import { defineReceiver } from '@drapejs/invoker';
import { fetchPage } from '@drapejs/core';
import { batch } from '@distancify/drapejs-litium';
import { gql } from 'graphql-request';

import { isPageType } from './shared';

import { getBreadcrumbsCacheKey } from '@/composables/useCategoryData';

export const schedule = defineReceiver(
  fetchPage,
  async function (command, data) {
    if (isPageType(data, 'Category')) {
      await this.invoke(batch.scheduleQuery, {
        cacheKey: getBreadcrumbsCacheKey(command.path),
        query: gql`
        categoryData(categorySystemId: $categorySystemId)`,
        variables: {
          categorySystemId: {
            value: data.categorySystemId || '',
            type: 'Guid',
          },
        },
      });
    }
  }
);
